export class FilterKeyValue {
    Label: string;
    Value: number;
}

